import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface User {
  id: string
  name: string
  email: string
  avatar?: string
  role: 'guest' | 'user' | 'admin'
}

interface UserState {
  currentUser: User | null
  isAuthenticated: boolean
  isLoading: boolean
  showLoginModal: boolean
}

const initialState: UserState = {
  currentUser: null,
  isAuthenticated: false,
  isLoading: false,
  showLoginModal: false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload
      state.isAuthenticated = true
    },
    clearUser: (state) => {
      state.currentUser = null
      state.isAuthenticated = false
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.currentUser) {
        state.currentUser = { ...state.currentUser, ...action.payload }
      }
    },
    showLoginModal: (state) => {
      state.showLoginModal = true
    },
    hideLoginModal: (state) => {
      state.showLoginModal = false
    },
  },
})

export const { setUser, clearUser, setLoading, updateUser, showLoginModal, hideLoginModal } = userSlice.actions
export default userSlice.reducer